import AcademyResultsApp from "./AcademyResultsApp.vue";
import { vueAppWithPinia } from "../Common/vueApp";

export default vueAppWithPinia(AcademyResultsApp);
